export default __webpack_public_path__ + "static/bg-how-it-work-82d74cbfc82b465c75f6a24315b19a9d.png";